import { render, staticRenderFns } from "./chart-bar.vue?vue&type=template&id=918a74e2&"
import script from "./chart-bar.vue?vue&type=script&lang=js&"
export * from "./chart-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports